"use strict";

import Common from "../Common";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Spray() {
    // Constants.
    this.DENSITY = 40;
    this.PERIOD = 0.05;
    this.RADIUS = 15;


    // Attributes.
    this._drawLayer = null;
    this._drawPosition = null;
    this._colour = null;
    this._audio = null;
}
export default Spray;
//module.exports               	= Spray;
Spray.prototype.constructor = Spray;


//===================================================
//
// Public
//
//===================================================

Spray.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;
    this._colour = Common.assets.getJSON("config").palettePanel.pages[0][0];

    // Signals.
    Common.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

Spray.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};


//===================================================
//
// Private
//
//===================================================

Spray.prototype._draw = function () {
    if (this._drawPosition == null)
        return;

    for (var i = this.DENSITY; i--;) {
        this._drawLayer.context.save();

        this._drawColour();

        this._drawLayer.context.restore();
    }

    TweenMax.delayedCall(this.PERIOD, this._draw, null, this);

    this._drawLayer.onContext_Changed();
};

Spray.prototype._drawColour = function () {
    var angle = Common.randomFloat(0, Math.PI * 2);
    var radius = Common.randomFloat(0, this.RADIUS);

    this._drawLayer.context.fillStyle = this._colour;
    this._drawLayer.context.globalAlpha = Math.random();
    this._drawLayer.context.fillRect(
        this._drawPosition.x + radius * Math.cos(angle),
        this._drawPosition.y + radius * Math.sin(angle),
        Common.randomFloat(1, 2), Common.randomFloat(1, 2));
};


//===================================================
//
// Events
//
//===================================================

Spray.prototype.onDrawBegan = function (point) {
    this._drawPosition = new PIXI.Point(point.x, point.y);

    this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';

    this._draw();

    // Sfx.
    this._audio = Common.audio.playSound("sfx_tool_spraycan_use_loop_00", {"loop": true});
};

Spray.prototype.onDrawMoved = function (from, to) {
    this._drawPosition.x = to.x;
    this._drawPosition.y = to.y;
};

Spray.prototype.onDrawEnded = function () {
    TweenMax.killTweensOf(this);
    this._drawPosition = null;


    // Sfx.
    this._stopAudio();
};

Spray.prototype._onColour_Changed = function (selection) {
    if (selection.indexOf("#") == 0)
        this._colour = selection;
};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    Spray.prototype,
    "paletteItem",
    {
        get: function () {
            return this._colour;
        }
    });